import React from 'react';
import { Row } from '@thd-olt-component-react/grid';
import { arrayOf, shape, string } from 'prop-types';
import './info-guides.scss';
import { DocumentList } from '../DocumentList/DocumentList';
import { DownloadAdobe } from '../DownloadAdobe/DownloadAdobe';

export const InfoGuides = (props) => {
  const { documents, channel } = props;
  const isDesktop = channel === 'desktop';

  return (
    <Row className="info-guides-wrapper">
      <div id="more-info" className="info-guides">
        <h3 className="info-guides__title">Info &amp; Guides</h3>
        <DocumentList documents={documents} />
        {isDesktop && <DownloadAdobe />}
      </div>
    </Row>
  );
};

InfoGuides.displayName = 'InfoGuides';

InfoGuides.propTypes = {
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  channel: string.isRequired
};
